import { ContactCardSkeleton } from '../../../../Utils/skeletonLoader/ContactCard'

export const CardSkeleton = () => {
    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                width: "100%",
                padding: "10px",
                gap: 20,
            }}
        >
            {/* Show multiple skeleton cards while loading */}
            {Array.from({ length: 8 }).map((_, index) => (
                <ContactCardSkeleton
                    key={index}
                    value={index}
                ></ContactCardSkeleton>
            ))}
        </div>
    )
}
